import Box, { BoxProps } from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { memo } from 'react';
// @mui

// ----------------------------------------------------------------------

function RiskIcon({ ...other }: BoxProps) {
  const theme = useTheme();

  const SUCCESS_DARK = theme.palette.success.dark;

  return (
    <Box {...other} display="flex">
      <Box component="svg" width="19px" height="18px" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.5 5.25V12.75M9.5 8.25V12.75M12.5 11.25V12.75M17 9C17 13.1421 13.6421 16.5 9.5 16.5C5.35786 16.5 2 13.1421 2 9C2 4.85786 5.35786 1.5 9.5 1.5C13.6421 1.5 17 4.85786 17 9Z"
          stroke={SUCCESS_DARK}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Box>
    </Box>
  );
}

export default memo(RiskIcon);
